export default {
    get(numOrName) {
        for(let item of this.items) {
            let eq = false
            if(typeof numOrName === 'number' && item[0] === numOrName) eq = true
            if(typeof numOrName === 'string' && item[1] === numOrName) eq = true
            if(eq) {
                return {
                    num: item[0],
                    name: item[1],
                    title: item[2],
                }
            }
        }
        return null
    },

    items: [
        [0, '', 'Главная'],
        [1, 'start', 'Поиск реквизитов'],
        [2, 'company', 'Информация о ЮЛ или ИП'],
        [3, 'contacts', 'Контактная информация'],
        [4, 'points', 'Точки оказания услуги'],
        [5, 'files', 'Файлы'],
        [6, 'validation', 'Проверка данных'],
        [7, 'finish', 'Финиш!'],
    ]
}